import { SAVE_SEARCH_MODAL_ID } from 'tradera/apps/tradera/components/discover/components/search-results/save-search-modal';
import {
    stripPaginationFromQueryParameters,
    stripSaveSearchNameFromQueryParameters,
    toSearchString
} from 'tradera/utils/url';
import { openModal, showSaveSearchBanner } from '../ui/reducer';
import { getPersonalisedSearches } from './api';
import {
    setRecentSearchLocalStorage,
    removeRecentSearchLocalStorage
} from './helpers';
import {
    setPersonalisedSearches,
    setPersonalisedSearchesStatus,
    setRecentSearches,
    removeRecentSearch
} from './reducer';
import cookieUtil from 'tradera/utils/cookie';
import { SAVE_SEARCH_MODAL_DISMISSED } from 'tradera/constants/cookies';
import * as searchGtm from 'tradera/apps/tradera/components/discover/helpers/search-gtm';

export const fetchPersonalisedSearchesIfNeeded =
    () => async (dispatch, getState) => {
        const { status } = getState().personalisation.searches;
        if (status !== 'NOT_FETCHED') return;

        dispatch(setPersonalisedSearchesStatus('LOADING'));

        const searchesResult = await getPersonalisedSearches();

        const newStatus =
            searchesResult.length > 0 ? 'HAS_DATA' : 'HAS_NO_DATA';
        dispatch(
            setPersonalisedSearches({
                items: searchesResult,
                status: newStatus
            })
        );
    };

export const addRecentSearches =
    (queryParams, growthbook) => async (dispatch, getState) => {
        const { q } = queryParams;

        const prettySearchTerm = q
            .toString()
            .replace(/</g, ' ')
            .replace(/>/g, ' ')
            .trim()
            .toLowerCase();

        const recentSearches = getState().personalisation.recentSearches;

        const existingSearch = recentSearches.find(
            (search) => search.text === prettySearchTerm
        );

        let count = 1;

        const searchQueryParams = stripPaginationFromQueryParameters(
            stripSaveSearchNameFromQueryParameters(queryParams)
        );

        if (existingSearch) {
            const isSameSearch =
                toSearchString(existingSearch.queryParams).toLowerCase() ===
                toSearchString(queryParams).toLowerCase();

            if (isSameSearch) {
                count = existingSearch.count + 1;

                const featureValue = growthbook?.getFeatureValue(
                    'tgl-339-a-a-b-save-search-bottom-banner',
                    'disabled'
                );

                const saveSearchBannerEnabled = featureValue === 'enabled';

                if (saveSearchBannerEnabled) {
                    if (count % 2 == 0) {
                        dispatch(showSaveSearchBanner());
                    } else {
                        dispatch(showSaveSearchBanner(false));
                    }
                } else {
                    const dismissCount =
                        parseInt(
                            cookieUtil.readCookie(SAVE_SEARCH_MODAL_DISMISSED)
                        ) || 0;

                    if (count == 3 && dismissCount < 3) {
                        searchGtm.trackAction('Save search modal', 'Show');
                        dispatch(
                            openModal({
                                modalId: SAVE_SEARCH_MODAL_ID,
                                data: {
                                    queryParams: searchQueryParams
                                }
                            })
                        );
                    }
                }
            } else {
                count = existingSearch.count;
            }
        }

        setRecentSearchLocalStorage(prettySearchTerm, searchQueryParams, count);

        dispatch(
            setRecentSearches({
                text: prettySearchTerm,
                count,
                queryParams: searchQueryParams
            })
        );
    };

export const removeRecentSearches = (searchTerm) => async (dispatch) => {
    removeRecentSearchLocalStorage(searchTerm);
    dispatch(removeRecentSearch(searchTerm));
};
